export default "__VITE_ASSET__CPcernJx__"